'use client';
import ExternalLink from '@/components/elements/ExternalLink';
import { getLinkTargetData } from '@/utils/getLinkTargetData';
import { useModal, MODAL_TYPES } from '@/components/modal/ModalProvider';

/**
 * Known as Block A in Contentstack data. Has promo text and a button link.
 */
export default function PromoContentBlock({ settings }) {
  const { showModal } = useModal();
  const terms = settings?.terms?.[0];
  const linkData = getLinkTargetData(settings);

  if (!linkData) return null;

  const { linkText: CTAText, linkUrl: CTAUrl, linkType: CTAType } = linkData;

  const handleTermsClick = () => {
    if (terms?.campaign_terms) {
      showModal(MODAL_TYPES.heroContent, {
        content: terms?.campaign_terms,
        title: 'Terms and Conditions'
      });
    }
  };
  return (
    <article className="block-a bg-warm-pewter-60 flex min-h-full px-4 py-15 lg:max-w-[30%] lg:min-w-[30%] lg:px-15">
      <div className="w-full self-center text-center lg:text-left">
        {settings?.promo_pacing_text && (
          <span className="preheading-s border-promo-red text-promo-red border px-3 py-1">
            {settings?.promo_pacing_text}
          </span>
        )}
        {settings?.preheading && (
          <p
            className={`preheading-r lg:preheading-l text-promo-red uppercase ${settings?.promo_pacing_text ? 'pt-3' : ''}`}
          >
            {settings?.preheading}
          </p>
        )}

        {settings?.heading && (
          <h1 className="h4 lg:h1 py-3">{settings?.heading}</h1>
        )}
        {settings?.subheading && (
          <span className="body-s lg:body-l">{settings?.subheading}</span>
        )}
        <span className="inline-block">
          <button
            className="body-s sm:body-r lg:body-l ml-1 cursor-pointer border-0 underline transition-opacity duration-300"
            data-cy="hero-terms-modal-link"
            onClick={handleTermsClick}
            type="button"
          >
            Terms
          </button>
        </span>
        {CTAText && CTAUrl && (
          <ExternalLink
            internalLink={CTAType === 'internal' ? CTAUrl : undefined}
            externalLink={CTAType === 'external' ? CTAUrl : undefined}
            linkStyling="btn-primary btn mx-auto mt-5 max-w-[152px] px-0 py-3 lg:mx-0"
            dataCyAttribute="sale-cta"
          >
            <div className="btn-primary btn mx-auto mt-5 max-w-[152px] px-0 py-3 lg:mx-0">
              {CTAText}
            </div>
          </ExternalLink>
        )}
      </div>
    </article>
  );
}
